// components/shared/KpiAmount.jsx
// COMPONENTE CONDIVISO — SOLO PRESENTAZIONE.
// Riceve valori GIA' calcolati (net, vat, gross, vat_rate) e li renderizza con
// l'IMPONIBILE/NETTO come valore principale e IVA/Totale come microcopy.
// NON contiene: formule IVA, business rules, lookup aliquote, logiche contrattuali.
// La logica economica resta nel backend/read-model.
//
// Regola UI (coerente su Pagamenti, Fatturazione, Entrate, QE, report):
//   - Valore principale = IMPONIBILE / NETTO IVA
//   - Card grandi  (variant="extended"): Imponibile / + IVA X% / Totale (righe)
//   - Tabelle/dense (variant="compact"):  IVA X%: … · Totale: …
//   - Il LORDO NON e' mai il KPI principale.

import React from 'react';

const fmtEuro = (n) =>
  new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(n || 0));

const rateLabel = (rate) => {
  if (rate === null || rate === undefined || rate === '') return null;
  const n = Number(rate);
  if (isNaN(n)) return null;
  return Number.isInteger(n) ? `${n}%` : `${String(n).replace('.', ',')}%`;
};

export const KpiAmount = ({
  net,
  vat,
  gross,
  vatRate = null,
  variant = 'extended',
  valueClassName = 'text-2xl font-bold text-[#3C3C3C] leading-tight tabular-nums',
  className = '',
  testId,
}) => {
  const nn = Number(net || 0);
  const vv = Number(vat || 0);
  const gg = gross === null || gross === undefined ? nn + vv : Number(gross || 0);
  const rl = rateLabel(vatRate);
  const hasVat = Math.round(vv * 100) !== 0;

  if (variant === 'compact') {
    return (
      <div className={className} data-testid={testId}>
        <div className={valueClassName}>{fmtEuro(nn)}</div>
        {hasVat && (
          <div className="text-[11px] text-[#a3a3a3] mt-0.5 tabular-nums">
            IVA {rl ? `${rl}: ` : ''}{fmtEuro(vv)} · Totale: {fmtEuro(gg)}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={className} data-testid={testId}>
      <div className={valueClassName}>{fmtEuro(nn)}</div>
      <div className="mt-1 space-y-0.5 text-[11px] text-[#a3a3a3] leading-snug tabular-nums">
        <div>Imponibile {fmtEuro(nn)}</div>
        {hasVat ? (
          <>
            <div>+ IVA {rl ? `${rl} ` : ''}{fmtEuro(vv)}</div>
            <div className="font-semibold text-[#737373]">Totale {fmtEuro(gg)}</div>
          </>
        ) : (
          <div className="italic">IVA non applicata</div>
        )}
      </div>
    </div>
  );
};

export default KpiAmount;
